module.exports = __webpack_public_path__ + "img/layout-2.461927ad.png";